import { CoreButton, CoreModalDialogFooter } from '@components'
import { ReportActions, useProcessReportMutation } from 'mmfintech-backend-api'
import { tr, useFormValues } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useEffect } from 'react'
import type { ReportActionModalProps } from '../@types'

import '../RejectModal/rejectModal.scss'
import { toastSuccess } from '@utils'

export const ReturnModal = ({ handleSubmit }: ReportActionModalProps) => {
  const [_, { error, isLoading, reset }] = useProcessReportMutation()

  const { areValid, prepare, setValue, getValue, getError } = useFormValues({
    action: { value: ReportActions.REQUEST_EDIT },
    comment: { required: true, validation: 'safe-string' }
  })

  const onConfirm = async () => {
    if (areValid()) {
      try {
        await handleSubmit(prepare() as any)
        toastSuccess(
          tr('FRONTEND.REPORTS.ACTIONS.RETURN_REPORT_SUCCESS', 'The report has been returned successfully'),
          undefined,
          { position: 'top-center', style: { marginTop: '-50px' } }
        )
      } catch {}
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: reset only on unmount
  useEffect(() => {
    return () => {
      reset()
    }
  }, [])

  return (
    <div className='return-reject-modal-wrapper'>
      <div className='return-reject-modal-inner'>
        <div className='confirmation'>
          {tr('FRONTEND.REPORTS.ACTIONS.RETURN_REPORT_DESCRIPTION', 'Please specify a reason for return.')}
        </div>

        <textarea
          maxLength={255}
          placeholder={tr('FRONTEND.REPORTS.ACTIONS.REJECT_REPORT_LABEL_DESCRIPTION', 'Description.')}
          rows={4}
          onChange={e => setValue('comment', e.target.value)}
          value={getValue('comment')}
        />
      </div>

      <ErrorDisplay error={[error || getError('comment')]} />

      <CoreModalDialogFooter>
        <CoreButton
          text={tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
          onClick={onConfirm}
          variation='primary-black'
          data-test='return-report-button'
          isLoading={isLoading}
          size='large'
          fullWidth
        />
      </CoreModalDialogFooter>
    </div>
  )
}
